var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-help", style: `paddingTop:${_vm.barHeight}px` },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: "", "left-arrow": "" },
        on: { "click-left": _vm.handleBack },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow05.png"),
                    alt: "",
                  },
                  on: { "click-left": _vm.handleBack },
                }),
                _c("span", { staticClass: "tit-left" }, [
                  _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("lang.sevenKeepSignin.title1a")) +
              " " +
              _vm._s(_vm.$t("lang.sevenKeepSignin.title1b")) +
              " " +
              _vm._s(_vm.$t("lang.sevenKeepSignin.title1c")) +
              " "
          ),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule1"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule2"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule3"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule4"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule5"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule6"))),
        ]),
        _c("div", { staticClass: "text1" }, [
          _vm._v(_vm._s(_vm.$t("lang.sevenKeepSignin.rule7"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }